import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SavedHistoryApi } from 'src/app/core/api.gen';

interface FieldChange {
  fieldName: string;
  oldValue: string | null;
  newValue: string | null;
}

export interface RecruitmentHistoryRow {
  fieldName: string;
  modifiedBy: string;
  modifiedOn: string;
}

@Component({
  selector: 'app-recruitment-history',
  templateUrl: './RecruitmentHistory.Component.html',
  styleUrls: ['./RecruitmentHistory.Component.scss'],
})
export class RecruitmentHistoryComponent implements OnInit {
  @Input() candidateId!: number;
  @Input() module!: 'PB' | 'IMM' | 'RMT';

  historyRows: RecruitmentHistoryRow[] = [];
  searchText = '';

  constructor(
    public modal: NgbActiveModal,
    private savedHistoryApi: SavedHistoryApi
  ) {}

  ngOnInit(): void {
    if (!this.candidateId || this.candidateId <= 0) {
      this.historyRows = [];
      return;
    }

    this.module = this.module ?? 'RMT';
    this.loadHistory();
  }
private loadHistory(): void {
  this.savedHistoryApi
    .recruitment(this.candidateId, this.module)
    .subscribe({
      next: (response: any[]) => {
        const rows: RecruitmentHistoryRow[] = [];
        const parseJob = (val: string | null): any => {
          try { return val ? JSON.parse(val) : {}; } catch { return {}; }
        };

        const buildDisplay = (text: string, code: string) =>
          text ? `${text} (${code || '-'})` : (code || '');

        (response || []).forEach(history => {
          const fields = (history.changedFields as FieldChange[]) || [];
          const seen = new Set<string>();
const sortedFields = [...fields].sort((a, b) => {
  const af = (a.fieldName || '').toLowerCase();
  const bf = (b.fieldName || '').toLowerCase();

  const aScore = af.endsWith('data') ? 0 : af.endsWith('id') ? 2 : 1;
  const bScore = bf.endsWith('data') ? 0 : bf.endsWith('id') ? 2 : 1;

  return aScore - bScore;
});

sortedFields.forEach(f => {
  let logicalKey = this.getLogicalKey(f.fieldName);
  logicalKey = this.normalizeAlias(logicalKey);
   if (this.HIDE_FIELDS.has(logicalKey.toLowerCase())) return;
  if (seen.has(logicalKey)) return;
  seen.add(logicalKey);

  rows.push({
    fieldName: f.fieldName,
    modifiedBy: history.modifiedByName ?? '',
    modifiedOn: history.modifiedDate
      ? new Date(history.modifiedDate).toLocaleString('en-GB', { hour12: false })
      : ''
  });
});
        });

        this.historyRows = rows;
      },
      error: () => {
        this.historyRows = [];
      }
    });
}
private FIELD_LABEL_MAP: Record<string, string> = {
  
  firstName: 'First name (as per passport)',
  middleName: 'Middle name (as per passport)',
  lastName: 'Last name (as per passport)',
  emailID: 'Email ID',
  personalEmailAddress: 'Personal Email ID',
  referenceSystem: 'SF ID',
  gui: 'GUI',
  gpn: 'GPN',
  otp: 'Candidate OTP',
employeeCategory: 'Employee category',
  onboardingType: 'Pre-boarding type',
  hireType: 'Hire type',
  contractType: 'Contract type',
  contractStatus: 'Contract status',
  contractDuration: 'Contract duration (months)',
  contractDurationIntern: 'Contract duration',
  contractDurationCW: 'Contract duration',
  probationPeriod: 'Probation period (months)',
  officeLocationCountry: 'Office location country',
  officeLocation: 'Office location',
  officeLegalEntity: 'Office legal entity',
  workLocation: 'Candidate work location',
  nationality: 'Nationality',
  serviceLine: 'Service line',
  subServiceLine: 'Sub-service line',
  speciality: 'Specialty',
  sector: 'Industry - sector',

  deptCode: 'Department',
  costCentre: 'Cost centre',

  jobTitle: 'Job title',
  currentVisaStatus: 'Current visa status',
  currentVisaExpiryDate: 'Current visa expiry date',
 degree: 'Degree Used for Visa Tagging',
  vaccinationStatus: 'Vaccination status',
  vaccineType: 'Vaccine type',
  biLingual: 'Bi-lingual (arabic speaker)',
  isConfidential: 'Confidential',
  isBRIT: 'Is this a business requested internal transfer',
  isBuddyApplicableId: 'Is Buddy Applicable',
  durationInCW: 'Contract duration type',
  
  recruiter: 'Recruiter name',
  buddyAllocator: 'Buddy allocator',
  counselorAllocator: 'Counselor allocator',
  eAallocatorId: 'EA Allocator',
  additionalEAallocatorId: 'Additional EA Allocator',
  referral: 'Referred by',

   transferTypeID: 'Transfer type',
  transferScenarioID: 'Transfer scenario',
  immigrationCaseTypeID: 'Immigration case type',
  currentVisaStatusID: 'Current visa status',
  profileSubmittedDate: 'Profile submitted date',
  submittedProfileDate: 'Profile submitted date',
  recruitmentHandoverDate: 'Profile approved date',
   invitedDate: 'Profile invited date',

   currentLocationCountryID: 'Current location - country',
   currentLocationId: 'Current location - city',
   lastWorkingday: 'Last working day/earliest availability to join',
   noticePeriodCW: 'Notice period (Days)',
   isNPNegotiableId: 'Is notice period negotiable',
   currentEmploymentStatusID: 'Current employment status',
   epRequestedDate: 'Employee profile requested date',
   epCreatedDate: 'Employee profile created date',
   eduDocAttestationId: 'Education document attestation',
   chargeCode: 'Charge code',
   dualCitizenshipId: 'Dual citizenship',
   secondNationalityId: 'Second nationality',
   approvedPreHireExceptions: 'Approved pre-hire exceptions',
   flightBookingID: 'Flight booking Eligibility',
   hotelBookingID: 'Hotel booking Eligibility',
   startDateCW: 'Start date',
   startdateStatusIdCW: 'Start date status',
   confirmedEnddateCW: 'Confirmed end date',

   'address.building': 'Building',
   'address.city': 'City',
   'address.street': 'Street',
   'bankDetails.isBankAvailable': 'Do you have bank account in the office location you are joining',
   'bankDetails.gccBankName': 'Bank name',
   'bankDetails.gccBankAccount': 'Bank account',
   'bankDetails.ibanNumber': 'IBAN number',
   'insuranceDetils.insuranceExist': 'Do you have an existing Medical Insurance plan',
   'insuranceDetils.isItGovtInsurance': 'If yes, is it provided by a Government entity',
   'choiceOfMedicalInsurance': 'Choice of medical insurance',
   'emergencyDetails.name': 'Emergency contact name',
   'emergencyDetails.relationship': 'Emergency contact relationship',
   'emergencyDetails.mobile': 'Emergency contact mobile',
   'emergencyDetails.email': 'Emergency contact email',
    travelPlan: 'Travel plan',
   'travelPlans.isDependentsTravelling': 'Do you have dependents travelling ',
   'travelPlans.dependentTravelingCount': 'Number of dependents',
   'travelPlans.preferredTravelTime': 'Preferred travel time',
   'travelPlans.familyMembersRelocating': 'Is family members relocating',
   'travelPlans.closestInternationalAirport': 'Closest international airport',

   'itPersonalInfo.holdEmploymentVisa': 'Do you currently hold an EY employment visa',
   'itPersonalInfo.istravellingShortly': 'Will you be travelling in the next two months',
   'itPersonalInfo.travellingDate': 'Travel date',
   'itPersonalInfo.travelLocation': 'Travel location',
   'itPersonalInfo.tripDuration': 'Trip duration',
   'itPersonalInfo.isBusinessTrip': 'Is this a business or a personal trip',
   'itPersonalInfo.transferDate': 'What is your expected transfer date based on discussions with your Manager/ Partner',
   'itPersonalInfo.isEngagedInAnyProject': 'Are you currently engaged on any projects that must be completed before your transfer date',
   'itPersonalInfo.projectName': 'Project name',
   'itITInformation.haveCurrentOfficeEquipment': 'Do you have an EY laptop/other IT equipment that has been provided by your current office',
   'itITInformation.haveAccesstoMailbox': 'Do you need access to your current mailbox after your transition period',
   'itITInformation.dicussedRequirementWithITteam': 'Have you discussed the IT requirement with your current office local IT team',
   'itFinacialInformation.hasOutstandingLoans': 'Do you have any outstanding loans with EY or payroll deductions in your current office',

   'itFinacialInformation.haveOutstandingreimbursements': 'Do you have any outstanding reimbursements or expenses on mercury',
   'itFinacialInformation.eosb': 'End of service benefits (EOSB)',
   'itLeaveInformation.hasOutstandingLeave': 'Do you have outstanding leave balance for the current financial year',
   'itLeaveInformation.howToManageLeave': 'How would you like to manage your outstanding leave balance',
   'itLeaveInformation.totalDaysInFY': 'How many days in total for this FY',
   previousEmployee: 'Do you have any work experience',
   previousEyEmployee: 'Have you ever worked for EY before',
   previousBigFour: "Have you worked for any 'other' Big Four previously",
   previousEyLocation: 'Previous EY location',
   'lastEmployerDetail.lastEmployerName': 'Company Name',
   'lastEmployerDetail.lastEmployerLocation': 'Location',
   'lastEmployerDetail.lastEmployerStartDate': 'Start date',
   'lastEmployerDetail.lastEmployerEndDate': 'End date',
   
    spouseDetails:'Spouse details',
   childrenDetails:'Child details',
   kinDetails:'Name of next of kin',
recruitmentAdmin: 'Recruitment admin',
additionalManager: 'Additional manager name',
hiringManager: 'Hiring manager name',
pjcAdminData:'PJC admin',

otc: 'PJC name',
ptcGUI: 'PJC GUI',
rank: 'Rank',
jobCode: 'Grade',
visaNumber: 'Visa number',
visaDesignation: 'Visa designation',


signOnBonus: 'Sign-on-bonus',
isCounselorChangeRequired: 'Counselor change required',
isCounseleesRetained: 'Will existing counselees be retained',
portOfExitCountry: 'Port of exit - country',
portOfExitCity: 'Port of exit - city',
previousEYExperience: 'Previous EY experience'
};

private HIDE_FIELDS = new Set<string>([
  'inviteddate'
]);
private getLogicalKey(fieldName: string): string {
  const key = (fieldName || '')
    .replace(/\.id$/i, '')
    .replace(/IdCW$/i, '')
    .replace(/Id$/i, '')
    .replace(/ID$/i, '')
    .replace(/Data$/i, '')
    .replace(/^job\./i, '');
  if (/^[A-Z]{2,}$/.test(key)) {
    return key.toLowerCase();
  }
  return key.charAt(0).toLowerCase() + key.slice(1);
}

private normalizeAlias(key: string): string {
  if (key === 'visaNumberandDesignation' || key === 'visanNoAndDesignation') {
    return 'visaDesignation';
  }
  return key;
}

getFieldLabel(fieldName: string): string {
  
  if (!fieldName) {
    return '';
  }
  let normalizedKey = this.getLogicalKey(fieldName);
normalizedKey = this.normalizeAlias(normalizedKey);

  if (this.FIELD_LABEL_MAP[normalizedKey]) {
    return this.FIELD_LABEL_MAP[normalizedKey];
  }
  if (normalizedKey === 'job') {
    return 'Rank';
  }

 
  const withoutId = fieldName.replace(/Id$/i, '');
  if (/^[A-Z0-9]+$/.test(withoutId)) {
    return withoutId;
  }

const ACRONYMS = ['PJC', 'OTC', 'PTC', 'GPN', 'GUI', 'EA'];

let label = normalizedKey
  .replace(/([a-z0-9])([A-Z])/g, '$1 $2');

ACRONYMS.forEach(a => {
  const regex = new RegExp(`\\b${a.toLowerCase()}\\b`, 'gi');
  label = label.replace(regex, a);
});

return label.replace(/\b\w/g, c => c.toUpperCase());
}
get filteredRows(): RecruitmentHistoryRow[] {
  if (!this.searchText) return this.historyRows;
  const t = this.searchText.trim().toLowerCase();
  return this.historyRows.filter(r =>
    this.getFieldLabel(r.fieldName).toLowerCase().includes(t)
  );
}

}
